import { DataCache, QueryResultsRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { UserPermissionsResponse } from 'data/models/UserPermissionsResponse';

export class UserPermissionsCache extends DataCache {
    UserPermissionsResponses = PCCollection(UserPermissionsResponse);

    constructor(data : PCCache) {
        super();

        new QueryResultsRelationship(this.UserPermissionsResponses, data.Roles, r => r.AssignableRoles);
        new QueryResultsRelationship(this.UserPermissionsResponses, data.PCUsers, r => r.Users);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/userpermissions/cache.ts